import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Input from '@components/form/input';
import ModalHeader from '@components/modal/modal-header';
import { Button } from '@components/shared/button';
import { GridCommon } from '@components/shared/common';
import { StyledModal } from '@components/shared/modal';
import { GuestInfo } from '@components/yoga/session.styled';
import { useYogaSaunaState } from '@context/yoga-sauna';
import { errors } from '@utils/errors';

const defaultProps = {
  initialValues: {
    email: '',
  },
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email(errors.invalidField('Email'))
      .required(errors.requiredField('email')),
  }),
} as any;

type GuestInfoModel = {
  bookForGuest: (val: { email: string }) => void;
  closeModal: () => void;
};

const GuestInfoModal = (
  props: GuestInfoModel & Readonly<typeof defaultProps>,
): React.ReactElement => {
  const { initialValues, validationSchema, bookForGuest, closeModal } = props;
  const { guestEmailError } = useYogaSaunaState();

  return (
    <StyledModal isOpen>
      <ModalHeader title="GUEST EMAIL" />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={bookForGuest}
      >
        <GuestInfo>
          <Input
            name="email"
            type="email"
            label="ADD YOUR GUEST'S EMAIL"
            placeholder="Enter email"
          />
          {guestEmailError && <span>Invalid Email</span>}
          <GridCommon
            gridColumn="1fr 1fr"
            mgridColumn="1fr 1fr"
            gridGap="20px"
            pt="10px"
          >
            <Button type="button" variant="outline" onClick={closeModal}>
              Go Back
            </Button>
            <Button type="submit">Next</Button>
          </GridCommon>
        </GuestInfo>
      </Formik>
    </StyledModal>
  );
};

GuestInfoModal.defaultProps = defaultProps;
export default GuestInfoModal;
